angular.module('taric.certificate.lookup', ['taric.model.certificate', 'common.filter.certificate', 'common.helper'])
    .controller('CertificateLookupController', function (CONSTANTS, CertificateLookupModel, CommonHelper, certificateTypes, $state, $stateParams, $rootScope, $timeout) {
        var certificateLookupCtrl = this;

        certificateLookupCtrl.init = function () {
            // If an invalid certificateType is passed as parameter from other use cases, it needs to be set to null.
            if (CertificateLookupModel.getSearchCriteria().certificateType) {
                var validCertificateType = false;
                for (let i = 0; i < certificateTypes.items.length; i++) {
                    if (CertificateLookupModel.getSearchCriteria().certificateType === certificateTypes.items[i].type) {
                        validCertificateType = true;
                        break;
                    }
                }
                if (!validCertificateType) {
                    CertificateLookupModel.getSearchCriteria().certificateType = null;
                }
            }
            
            certificateLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            certificateLookupCtrl.searchCriteria = CertificateLookupModel.getSearchCriteria();
            certificateLookupCtrl.searchResult = CertificateLookupModel.getSearchResult();
            certificateLookupCtrl.dateFormat = CONSTANTS.dateFormat;
            certificateLookupCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            certificateLookupCtrl.installationCountry = CONSTANTS.installationCountry;
            certificateLookupCtrl.certificateTypes = certificateTypes;
        };

        certificateLookupCtrl.search = function () {
            //Load data for the first page
            this.loadDataFromServer(1);
        };

        //Load data for a given page
        certificateLookupCtrl.loadDataFromServer = function(page){
            // Reset search result before searching
            certificateLookupCtrl.resetSearchResult();
            certificateLookupCtrl.searching = true;
            CertificateLookupModel.queryCertificates(page).then(function(searchResult) {
                certificateLookupCtrl.searchResult = searchResult;
                certificateLookupCtrl.searching = false;
            }, function(error){
                certificateLookupCtrl.errorCode = error.data.code;
                certificateLookupCtrl.errorParams = error.data.params;
                certificateLookupCtrl.searching = false;
            });
        };

        certificateLookupCtrl.resetSearchResult = function() {
            certificateLookupCtrl.searchResult = null;
            CertificateLookupModel.resetSearchResult();
        };

        //Handle page change for the Additional code search result table
        certificateLookupCtrl.searchResultPageChanged = function (page) {
            certificateLookupCtrl.loadDataFromServer(page);
        };

        certificateLookupCtrl.openDatePicker = function ($event) {
            certificateLookupCtrl.isDatePickerOpen = true;
        };

        certificateLookupCtrl.resetError = function(){
            certificateLookupCtrl.handleError(null);
        };

        certificateLookupCtrl.handleError = function(error){
            if(!error){
                certificateLookupCtrl.errorCode = null;
                certificateLookupCtrl.errorParams = null;
            } else {
                certificateLookupCtrl.errorCode = error.errorCode;
                certificateLookupCtrl.errorParams = error.errorParams;
            }
        };

        certificateLookupCtrl.returnToCallerPage = function (certificateTypeAndId) {
            // Do not return simulationDate to CallerPage to avoid affecting other search criteria.
            $state.go($stateParams.frm, {
                ce: CommonHelper.removeSpaceCharacters(certificateTypeAndId),
                frm: 'certificateLookup'
            });
        };

        certificateLookupCtrl.onChangeCertificate = function(){
            certificateLookupCtrl.searchCriteria.certificateId = certificateLookupCtrl.searchCriteria.certificateId.toUpperCase();
        };

        certificateLookupCtrl.hasNationalCertificateTypes = function(){
            var nationalCertificateTypes = certificateLookupCtrl.certificateTypes.items.filter(function(certificateType){
                return certificateType.national === true;
            });
            return nationalCertificateTypes.length > 0;
        };

        certificateLookupCtrl.isTooltipEnable = function(descriptions){
            return CommonHelper.isTooltipEnable(descriptions);
        };

        certificateLookupCtrl.onDateChange = function (dateString) {
            certificateLookupCtrl.resetError();
            certificateLookupCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(certificateLookupCtrl.searchCriteria.simulationDate, dateString);
        };

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            certificateLookupCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                certificateLookupCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });

    });


// WEBPACK FOOTER //
// ./app/taric/certificate/lookup/certificate-lookup.js